import { fireErrorAnalytics as fireErrorAnalyticsCommon } from '@atlassian/jira-errors-handling';
import type { AnalyticsAttributes } from '@atlassian/jira-product-analytics-bridge';
import { PACKAGE_NAME, PACKAGE_TEAM_NAME } from './constants';

type fireErrorAnalyticsParams = {
	attributes: AnalyticsAttributes;
	error?: Error;
	skipSentry?: boolean;
};

export const fireErrorAnalytics = ({
	attributes,
	error,
	// will want to skip sentry in cases where have no control over the errors
	// so don't want to get alerted based on sentry error thresholds
	skipSentry = false,
}: fireErrorAnalyticsParams) => {
	fireErrorAnalyticsCommon({
		meta: {
			id: 'autoEnableDES',
			packageName: PACKAGE_NAME,
			teamName: PACKAGE_TEAM_NAME,
		},
		attributes,
		error,
		sendToPrivacyUnsafeSplunk: true,
		skipSentry,
	});
};
